/** @format */

import React, { Component } from "react";
import "./contact.css";

class Contact extends Component {
  render() {
    return (
      <div id="contact" className="clearfix dt_row contact">
        <div id="dt_column_47" className="dt_column col-sm-12">
          <div id="krypton-map48" className="module_dt_contact_form">
            <section className="map-image-area">
              <div className="map">
                {/* <div className="circle-address uk-scrollspy-init-inview uk-scrollspy-inview uk-animation-fade" data-uk-scrollspy="{cls:'uk-animation-fade', delay:600}">
                  <section>
                    <h1>2</h1>
                    Marina Boulevard
                    <hr></hr>
                    Tower 1 #13-01<br />
                     018987
                  </section>
                </div> */}
                <div className="map-info hidden-xs">
                  <div className="container">
                    <div className="row">
                      <div className="col col-sm-6 col-xs-6">
                        <div className="icon-container">
                          <i className="fa fa-map-marker"></i>
                        </div>
                        <address className="address">
                          {/* 112 Robinson Road #12-01 <br /> Singapore 068902 */}
                          9 Raffles Place, Singapore 048619
                        </address>
                      </div>
                      {/* <div className="col col-sm-4 col-xs-4">
                        <div className="icon-container">
                          <i className="fa fa-phone"></i>
                        </div>
                        <div className="phone">+65 6909 9266</div>
                      </div> */}
                      <div className="col col-sm-6 col-xs-6">
                        <div className="icon-container">
                          <i className="fa fa-envelope"></i>
                        </div>
                        <div className="email">
                          <a href="mailto:info@33-capital.com">
                            info@33-capital.com
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/components/Contact/index.js